import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import FrCheckWhiteSvg from '@src/svgs/fr-check-white.svg';
import './styles.scss';

export default class Checkbox extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    disableStateChange: PropTypes.bool,
    disabled: PropTypes.bool,
    invalid: PropTypes.bool,
    label: PropTypes.node,
    labelLeft: PropTypes.bool,
    onChange: PropTypes.func,
    propagateEvent: PropTypes.bool,
    style: PropTypes.oneOf(['default', 'highlighted']),
    value: PropTypes.bool,
    wrapperClassName: PropTypes.string,
  };

  state = {
    checked: !!this.props.value,
  };

  componentWillReceiveProps(props) {
    this.setState({ checked: !!props.value });
  }

  preventEventPropagation = evt => evt.stopPropagation();

  onClick = evt => {
    const { propagateEvent, onChange, disableStateChange } = this.props;

    if (!propagateEvent) {
      this.preventEventPropagation(evt);
    }

    if (!disableStateChange) {
      this.setState(
        ({ checked }) => ({ checked: !checked }),
        () => onChange && onChange(this.state.checked),
      );
    } else {
      onChange && onChange();
    }
  };

  render() {
    const { label, wrapperClassName, className, invalid, disabled, labelLeft, style } = this.props;
    const { checked } = this.state;

    return (
      <label
        className={classnames(
          'frank-checkbox',
          style === 'highlighted' && 'frank-checkbox--highlighted',
          labelLeft && 'frank-checkbox--label-left',
          checked && 'active',
          disabled && 'frank-checkbox--disabled',
          wrapperClassName,
        )}
      >
        <input disabled={disabled} onClick={this.onClick} type="checkbox" value={checked} />

        <Svg
          className={classnames(
            'frank-checkbox-icon',
            className,
            checked && 'frank-checkbox-checked',
            invalid && 'invalid',
          )}
          onClick={this.preventEventPropagation}
          src={FrCheckWhiteSvg}
        />

        {label && <span>{label}</span>}
      </label>
    );
  }
}
